<template>
    <el-row type="flex" class="model-table-search btn-bg">
        <el-col id='search-input-guide' :span="21">
            <el-row class="search-box">
                <el-col :span="data.span" v-for="(data,index) in list.searchTxt" :key="index">

                    <div class="search" v-if="data.type==='input' || !data.hasOwnProperty('type')">
                        <el-input class="inputBorderV3" v-model="searchData[data.value]" :placeholder="data.name"></el-input>
                    </div>
                    <div class="search" v-if="data.type ==='datePicker'">
                        <el-date-picker class="datePickBorderV3" v-model="searchData[data.value]" type="datetimerange" align="left" value-format='yyyy-MM-dd HH:mm:ss'
                            :default-time="['00:00:00', '23:59:59']" unlink-panels range-separator="-" :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                            :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })" size="mini" :picker-options="pickerOptions"></el-date-picker>
                    </div>
                    <div class="search" v-if="data.type ==='select'">
                        <el-select
                            v-model="searchData[data.value]"
                            :placeholder="data.name"
                            clearable filterable collapse-tags
                            @change="((val)=>{cascadeChange(val, data)})">
                            <el-option v-for="(val, index) in data.options" :key='index' :label="val.label" :value="val.value"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="6" v-if="list.isInquire">
                    <div class="select-btn-box">
                        <el-button class="blueBtV3" type="primary" @click="onSearchChange" :loading="loading" id="search">
                            {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                        </el-button>
                        <slot name="table-module-btn-left"></slot>
                    </div>
                </el-col>
            </el-row>
        </el-col>
        <el-col :span="3">
            <el-row>
                <el-col>
                    <slot name="table-module-btn"></slot>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</template>
<script>
import formatTime from '@/utils/common.js';
import dayjs from 'dayjs';
export default {
    props: {
        list: {
            type: Object,
            default() {
                return {};
            }
        },
        loading: {
            type: Boolean,
            default() {
                return null;
            }
        }
    },
    data() {
        return {
            searchData: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202101270017', { defaultText: '最近一周' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', { defaultText: '最近一个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270021', { defaultText: '最近三个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(90), formatTime.initEndDate()]);
                        }
                    }
                ]
            }
        };
    },
    methods: {
        restSearchChange() { // 重置
            this.searchData = {};
        },
        onSearchChange() {
            this.$emit('onSearchChange', this.searchData);
        },
        clearsearchData() {
            this.searchData = {};
        },
        cascadeChange(val, configuration) {
            if (configuration.iscascade) {
                this.$set(this.searchData, configuration.iscascadeObject, '');
            };
            this.$emit('cascadeChange', val, configuration);
        },
        dataInit() {
            const searchData = {};
            this.list.searchTxt.forEach((data) => {
                if (data.type === 'datePicker' && data.timeNum) {
                    const today = dayjs();
                    const startOfDay = today.startOf('day');
                    const endOfDay = today.endOf('day');
                    const start = data.future ? startOfDay.toDate() : startOfDay.subtract(data.timeNum, 'd').toDate();
                    const end = data.future ? endOfDay.add(data.timeNum, 'd').toDate() : today.endOf('day').toDate();
                    searchData[data.value] = [start, end];
                }
            });
            this.searchData = searchData;
        }
    },
    mounted() {
        this.dataInit();
    }
};
</script>
<style lang="less">
.model-table-search {
    .search-box {
        .el-date-editor--datetimerange.el-input__inner {
            width: 100%;
        }
        flex-wrap: wrap;
        .search {
            margin: 0 8px 10px 0;
        }
        .advanced-btn {
            margin-left: 10px;
        }
    }
    .text-box {
        position: relative;
        font-size: 12px;
        width: 100%;
    }
    .select-btn-box {
        display: flex;
        .blueBtV3 {
            margin-right: 10px;
        }
    }
    .el-autocomplete,
    .el-select {
        width: 100%;
    }
}
</style>
